import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const OrderAvailability = () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Availability.vue');
const OrdersList = () => import(/* webpackChunkName: "orders" */ '@/views/Orders/List.vue');
const OrderCreate = () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Create.vue');
const OrderEdit = () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Edit.vue');
const OrderShow = () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Show.vue');
const OrdersStatistics = () => import(/* webpackChunkName: "orders" */ '@/views/Orders/Statistics.vue');

let ordersPages = {
  path: '/orders',
  redirect: '/orders',
  component: DashboardLayout,
  name: 'Orders',
  meta: {
    title: 'Pedidos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'OrdersList',
      meta: {
        title: 'Listado',
        auth: ['orders.index'],
      },
      component: OrdersList,
    },
    {
      path: 'statistics',
      name: 'OrdersStatistics',
      meta: {
        title: 'Estadísticas',
        auth: ['orders.statistics'],
      },
      component: OrdersStatistics,
    },
    {
      path: 'create',
      name: 'OrderCreate',
      meta: {
        title: 'Nueva',
        auth: ['orders.store'],
      },
      component: OrderCreate,
    },
    {
      path: ':id',
      name: 'OrderShow',
      meta: {
        title: 'Detalle',
        auth: ['orders.show'],
      },
      component: OrderShow,
    },
    {
      path: ':id/edit',
      name: 'OrderEdit',
      meta: {
        title: 'Editar',
        auth: ['orders.update'],
      },
      component: OrderEdit,
    },
    {
      path: ':id/availability',
      name: 'OrderAvailability',
      meta: {
        title: 'Disponibilidad',
        auth: ['orders.availability'],
      },
      component: OrderAvailability,
    },
  ],
};

export default ordersPages;
